import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import "./OrganizationChart.css";
import { Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDownLong, faUpload } from "@fortawesome/free-solid-svg-icons";
import Success_Toster from "../../../../../../common/common_modal/success_toster/Success_Toster";

/* ================= INPUT FIELD ================= */
const OrgChartInput = ({ placeholder }) => {
  return (
    <Form.Group className="form_group file_field">
      <div className="absolute_fields">
        <Form.Control placeholder={placeholder} />
      </div>
    </Form.Group>
  );
};

/* ================= COMPONENT ================= */
function OrganizationChart({handleClose}) {
  const [isGenerated, setIsGenerated] = useState(false);
  const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <>
      <section className="Imperiality OrgChartInput">
        <div className="back_div">
          <Common_Back_Btn backText="Organization Chart" />
        </div>

        <div className="org-chart-wrapper">
          {/* ACTION BUTTONS */}
          <div className="org-chart-actions">
            {!isGenerated ? (
              <div
                className="permission_btn_holder"
                style={{ borderTop: "none" }}
              >
                <Button
                  className="permission_btn Yes_btn"
                  onClick={() => setIsGenerated(true)}
                >
                  Generate Organization Chart
                </Button>
              </div>
            ) : (
              <div
                className="permission_btn_holder"
                style={{ borderTop: "none" }}
              >
                {!success ? (
                  <>
                    <Button type="button" className="permission_btn No_btn">
                      Download
                    </Button>

                    <Button
                      type="submit"
                      className="permission_btn Yes_btn"
                      onClick={() => {
                        setSuccess(true);
                      }}
                    >
                      Save
                    </Button>
                  </>
                ) : (
                  <Success_Toster successText={"Save Audit Successfully!"} />
                )}
              </div>
            )}
          </div>

          {/* ORGANIZATION CHART */}
          <div className="org-chart">
            <div className="box orange">
              {isGenerated ? (
                <OrgChartInput placeholder="Enter Name Of CEO LAB" />
              ) : (
                "CEO LAB"
              )}
              <span>(Manager Mines)</span>
            </div>

            <div className="arrow-down">
              <FontAwesomeIcon icon={faArrowDownLong} />
            </div>

            <div className="box aqua">
              {isGenerated ? (
                <OrgChartInput placeholder="Enter Name Of AQM" />
              ) : (
                "Area Quality Manager"
              )}
              <span>(AQM)</span>
            </div>

            <div className="arrow-down">
              <FontAwesomeIcon icon={faArrowDownLong} />
            </div>

            <div className="box purple">
              {isGenerated ? (
                <OrgChartInput placeholder="Enter Name Of QM" />
              ) : (
                "Quality Manager"
              )}
              <span>(QM)</span>
            </div>

            <div className="arrow-down">
              <FontAwesomeIcon icon={faArrowDownLong} />
            </div>

            <div className="box green">
              {isGenerated ? (
                <OrgChartInput placeholder="Enter Name Of TM" />
              ) : (
                "Technical Manager"
              )}
              <span>(TM)</span>
            </div>

            <div className="horizontal-line"></div>

            <div className="bottom-row">
              <div className="text-center">
                <div className="arrow-down">
                  <FontAwesomeIcon icon={faArrowDownLong} />
                </div>
                <div className="box pink">
                  {isGenerated ? (
                    <OrgChartInput placeholder="Enter Name Of Chemist" />
                  ) : (
                    "Lab Technician"
                  )}
                  <span>(Chemist)</span>
                </div>
              </div>
              <div className="text-center">
                <div className="arrow-down">
                  <FontAwesomeIcon icon={faArrowDownLong} />
                </div>
                <div className="box pink">
                  {isGenerated ? (
                    <OrgChartInput placeholder="Enter Name Of Assistant" />
                  ) : (
                    "Lab Technician"
                  )}
                  <span>(Assistant)</span>
                </div>
              </div>

              <div className="text-center">
                <div className="arrow-down">
                  <FontAwesomeIcon icon={faArrowDownLong} />
                </div>
                <div className="box pink">
                  {isGenerated ? (
                    <OrgChartInput placeholder="Enter Name Of Clerk" />
                  ) : (
                    "Clerk"
                  )}
                </div>
              </div>

              <div className="text-center">
                <div className="arrow-down">
                  <FontAwesomeIcon icon={faArrowDownLong} />
                </div>
                <div className="box pink">
                  {isGenerated ? (
                    <OrgChartInput placeholder="Enter Name Of Sample Receiver" />
                  ) : (
                    "Sample Receiver"
                  )}
                </div>
              </div>

              <div className="text-center">
                <div className="arrow-down">
                  <FontAwesomeIcon icon={faArrowDownLong} />
                </div>
                <div className="box pink">
                  {isGenerated ? (
                    <OrgChartInput placeholder="Enter Name Of Sampler" />
                  ) : (
                    "Sampler"
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default OrganizationChart;
